import React from 'react';
import { hooks, models } from "@vote4dance/judging-sdk";
import { HeaderContainer, BodyContainer } from "../../../../base-react/components/Container";
import { Typography, Table, Space, Empty } from 'antd';
import { Link, useParams } from "react-router-dom";
import { _T } from "../../../../base-react/src/Localization";
import { WarningFilled } from '@ant-design/icons';
import { useCompetition } from '../../../../base-react/hooks/Competition';
import { Loading } from '../../../../base-react/components/Loading';
var Stream = hooks.streams.Stream;
var CompetitionValidationSource = models.competitions.CompetitionValidationSource;
var TeamItem = models.teams.TeamItem;
var ClassItem = models.classes.ClassItem;
const { Text, Title } = Typography;
export const Validator = () => {
    let { event_id } = useParams();
    const [inputCompetition, event, competitions, loading] = useCompetition(event_id);
    const displayCompetitions = competitions && competitions.length > 0 ? competitions : event ? [event] : [];
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, null, _T('validator.title')))),
        React.createElement(BodyContainer, null,
            React.createElement(Space, { orientation: "vertical", size: "large", style: { width: '100%' } }, displayCompetitions && displayCompetitions.map((item, index) => (React.createElement(React.Fragment, { key: index },
                competitions && competitions.length > 0 &&
                    React.createElement(Typography, null,
                        React.createElement(Title, { level: 2 }, item.competition_name)),
                React.createElement(ValidatorCompetition, { competition_id: item.competition_id }))))))));
};
const ValidatorCompetition = (props) => {
    const [validations, loadingValidations] = Stream(CompetitionValidationSource(props.competition_id));
    if (loadingValidations) {
        return React.createElement(Loading, null);
    }
    const showValidations = validations && validations.filter((item) => !item.result);
    if (showValidations && showValidations.length === 0) {
        return React.createElement(Empty, null);
    }
    return (React.createElement(React.Fragment, null, showValidations && showValidations.map((item, index) => (React.createElement(Space, { orientation: "vertical", size: "large", style: { width: '100%' }, key: index },
        React.createElement(ValidatorTable, { validation: item }))))));
};
const ValidatorTable = (props) => {
    let { validation } = props;
    const getRowKey = (template) => {
        switch (template) {
            case 'round': return 'round_id';
            case 'team': return 'team_id';
            case 'class': return 'class_id';
            default: return 'class_id';
        }
    };
    const rowKey = getRowKey(validation.template);
    var data = [];
    validation.data.filter(function (item) {
        var i = data.findIndex((x) => (x[rowKey] == item[rowKey]));
        if (i <= -1) {
            data.push(item);
        }
        return null;
    });
    var columns = [];
    if (validation.template == "round") {
        columns = [
            {
                title: _T('round.details.round_label.label'),
                dataIndex: 'round_label',
                render: (text, item) => (React.createElement(Link, { to: `../comp/${item.competition_id}/classes/${item.class_id}/${item.round_id}` }, text))
            },
            {
                title: _T('class.title'),
                dataIndex: 'class_name',
                render: (text, item) => (ClassItem.getClassLabel(item))
            },
            {
                title: _T('schedule.title'),
                dataIndex: 'schedule_value',
                responsive: ['lg'],
            }
        ];
    }
    else if (validation.template == "team") {
        columns = [
            {
                title: '#',
                dataIndex: 'team_start_number'
            },
            {
                title: _T('team.details.team_name.label'),
                render: (text, item) => (React.createElement(Link, { to: `../comp/${item.competition_id}/teams/${item.team_id}` }, TeamItem.getFullNameWithOrg(item)))
            },
            {
                title: _T('team.details.team_org.label'),
                dataIndex: 'team_org'
            },
        ];
    }
    else if (validation.template == "class") {
        columns = [
            {
                title: _T('class.title'),
                dataIndex: 'class_name',
                render: (text, item) => (ClassItem.getClassLabel(item))
            }
        ];
    }
    return (React.createElement(Table, { title: () => (React.createElement(React.Fragment, null,
            React.createElement(Text, { type: "danger" },
                React.createElement(WarningFilled, null),
                " "),
            _T('validator.test-prefix-text'),
            _T(validation.test),
            React.createElement(Text, { strong: true }, _T('validator.test-suffix-error')))), size: "small", columns: columns, rowKey: rowKey, dataSource: data, pagination: false }));
};
